import React from 'react';
import ReactDOM from 'react-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';

import './index.css';
import './styles/agency.css'



import './pages/Dep'
import Home from './pages/Home';
import * as serviceWorker from './serviceWorker';


ReactDOM.render(<Home />, document.getElementById('page-top'));





// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister(); 
